export const BUY_FLOW = {
  NGC: "NGC",
  BAU: "BAU",
  DEFAULT: "DEFAULT",
} as const;

export type BuyFlow = (typeof BUY_FLOW)[keyof typeof BUY_FLOW];

export const BUY_FLOW_COOKIE_KEY = "buyFlow";
